import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import DateInputField from 'components/DateInputField';
import MarkdownEditor from 'components/MarkdownEditor';
import TagSelector from 'components/TagSelector';

import FormSection from 'ui/FormSection';

import { slugify } from 'utils/slugify';

import { Checkbox, FormControlLabel, TextField } from '@mui/material';

const Details = ({event, onEventChange, onChange, setUnsavedChanges}) => {

    const {title, location, secret_location, single } = event;

    const handleSecretLocationChange = ({ target: { checked } }) => {
        onChange({ target: { name: "secret_location", value: checked } });
    };
    const {organizationId} = useParams();

    const dateFields = [
        { attribute: 'start_date', label: 'Start Date *' },
        { attribute: 'end_date', label: 'End Date' },
    ]

  return (
    <FormSection title={"Event Info"}>
        <TextField
            fullWidth
            size='small'
            color='warning'
            name={"title"}
            label={"Title *"}
            value={title}
            onChange={onChange}
            onBlur={() => slugify(event, onEventChange)}
        />

        {single &&
            <div className='date-fields'>
                {dateFields.map((field, index) => (
                    <DateInputField
                        key={index}
                        attribute={field.attribute}
                        label={field.label}
                        object={event}
                        onChange={onEventChange}
                        setUnsavedChanges={setUnsavedChanges}
                        disablePast={true}
                    />
                ))}
            </div>
        }

        {!single &&
            <MarkdownEditor 
                object={event}
                setObject={onEventChange}
                attribute={"description"}
                placeholder={'Description'}
                allowImageUpload={true}
                allowEmbeds={true}
                setUnsavedChanges={setUnsavedChanges}
            />}

        <div className='row'> 
          <TextField
              fullWidth
              size='small'
              color='warning'
              name={"location"}
              label={"Location"}
              value={location}
              onChange={onChange}
          />
          <TagSelector
              object={event}
              onObjectChange={onEventChange}
              objectType={"event"}
              organizationId={organizationId} />
        </div>

        <FormControlLabel
          control={
            <Checkbox
              checked={!!secret_location}
              onChange={handleSecretLocationChange}
            />
          }
          label="Show secret location panel instead of map (location text remains visible)"
        />
    </FormSection>
  );
};

Details.propTypes = {
    event: PropTypes.object,
    onEventChange: PropTypes.func,
    onChange: PropTypes.func,
    setUnsavedChanges: PropTypes.func
};

export default Details;
